import React from 'react';
import PropTypes from 'prop-types';
import { efesGrayish } from '../../../theme';

const Instagram = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28.313 28.303">
    <path
      id="instagram-filled"
      d="M17.108,14.481a2.79,2.79,0,1,0-2.791,2.778A2.787,2.787,0,0,0,17.108,14.481ZM21.253.022H7.092A7.068,7.068,0,0,0,.016,7.066V9.029H10.428a6.721,6.721,0,0,1,7.779,0H28.328V7.066A7.067,7.067,0,0,0,21.253.022Zm2.865,6.7a.786.786,0,0,1-.786.782H20.9a.787.787,0,0,1-.786-.782V4.3a.786.786,0,0,1,.786-.782h2.429a.787.787,0,0,1,.786.782Zm-3.08,7.759a6.721,6.721,0,0,1-13.442,0,6.627,6.627,0,0,1,.638-2.842H.016v9.642a7.068,7.068,0,0,0,7.076,7.044H21.253a7.068,7.068,0,0,0,7.076-7.044V11.638H20.4a6.63,6.63,0,0,1,.638,2.842Z"
      transform="translate(-0.016 -0.022)"
      fill={color}
    />
  </svg>
);

Instagram.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};

Instagram.defaultProps = {
  width: 28.313,
  height: 28.303,
  color: efesGrayish,
};

export default Instagram;
